import React from "react";
import { CheckboxNew, CheckboxNewProps } from "../ui-lib/checkbox-new";
import MobileIconUi from "client/components/core/Sidebar/components/Settings/styles/ui/MobileIconUi";
import { useDeviceModeContext } from "client/context/DeviceModeContext";

type CheckboxControlProps = Omit<
  CheckboxNewProps,
  "handleChange" | "onChange" | "checked" | "value"
> & {
  value: CheckboxNewProps["checked"];
  update: CheckboxNewProps["onChange"];
  mobileValue?: CheckboxNewProps["checked"];
  mobileUpdate?: CheckboxNewProps["onChange"];
};

export const CheckboxControl = ({
  wrapperClassName = "",
  value,
  update,
  mobileValue,
  mobileUpdate,
  ...props
}: CheckboxControlProps) => {
  const { isMobile } = useDeviceModeContext();
  const onChange = isMobile && mobileUpdate ? mobileUpdate : update;
  const checked = isMobile ? mobileValue || value : value;
  return (
    <CheckboxNew
      wrapperClassName={`mt-3.5 ${wrapperClassName}`}
      icon={isMobile && mobileUpdate && <MobileIconUi />}
      onChange={onChange}
      checked={checked}
      {...props}
    />
  );
};
